export default "__VITE_ASSET__Qyd38rrd__"